<template>
	<section
		class="positionHeaderBackground"
		v-if="position"
		:class="`position-item--${position.departments[0].color}`"
	>
		<div class="solid--bg"></div>
		<div class="container positionInfo--wrapper">
			<a href="#" @click.prevent.stop="goBack" class="back-button">
				<i class="mobile-button icons8-jobapp-delete-01"></i>
				<i class="full-text-button icons8-arrow-left-slider--01"></i>
				<span class="full-text-button">View All Job Listings</span>
			</a>
			<div class="position-wrapper">
				<div class="positionInfo">
					<h1 class="position-title heading--lg">
						{{ position.title }}
					</h1>
					<!--<social-icons :slug="position.slug"></social-icons>-->
					<p class="paragraph">{{ position.short_description }}</p>

					<ul class="list--unstyled">
						<li class="list-heading">Office</li>
						<li>{{ position.location.city }}</li>
						<li class="list-heading">Discipline</li>
						<li>
							<span
								v-for="(department,
								index) in position.departments"
							>
								{{
									department.name +
										(index ===
										position.departments.length - 1
											? ""
											: ", ")
								}}
							</span>
						</li>
						<li class="list-heading" v-if="position.project">
							Project
						</li>
						<li v-if="position.project">
							{{ position.project.title }}
						</li>
					</ul>
					<div class="button-wrapper" style="bottom: 70px;"></div>

					<div class="button-wrapper">
						<div
							style="display: flex;flex-flow: column;align-items: flex-end;gap: 10px;"
						>
							<basic-button
								v-scroll-to="{
									element: '#apply-now',
									duration: 1000
								}"
								class="apply-button"
								type="black"
								>Apply Now
								<span class="arrow-down"
									><i class="icons8-arrow-up-slider--01"></i
								></span>
							</basic-button>
							<basic-button
								:is="isCoppied ? 'a' : 'basic-button'"
								type="black"
								@click="copyURL"
							>
								<div class="inner_btn">
									<span v-if="!isCoppied">Copy link</span>
									<svg
										v-if="!isCoppied"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="lucide lucide-clipboard-copy"
									>
										<rect
											width="8"
											height="4"
											x="8"
											y="2"
											rx="1"
											ry="1"
										/>
										<path
											d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
										/>
										<path d="M16 4h2a2 2 0 0 1 2 2v4" />
										<path d="M21 14H11" />
										<path d="m15 10-4 4 4 4" />
									</svg>
									<span v-if="isCoppied">Copied</span>
									<svg
										v-if="isCoppied"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="lucide lucide-check"
									>
										<path d="M20 6 9 17l-5-5" />
									</svg>
								</div>
							</basic-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { data } from "jquery";
import BasicButton from "../BasicButton";
import SocialIcons from "../common/SocialIcons";

export default {
	components: { SocialIcons, BasicButton },
	name: "PositionHeader",
	data() {
		return {
			isCoppied: false
		};
	},
	props: {
		position: {
			type: Object,
			required: true
		},
		fromMain: {
			type: Boolean
		}
	},
	methods: {
		goBack() {
			if (this.fromMain) {
				this.$router.push("/positions");
			} else {
				this.$router.go(-1);
			}
		},
		async copyURL() {
			try {
				this.isCoppied = true;
				const url = document.location.href;
				await navigator.clipboard.writeText(url);
			} catch ($e) {
				console.error(e);
			}
		}
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";
@import "../../assets/scss/mixins";

.position-title {
	word-wrap: normal;
	@media (max-width: $compact) {
		font-size: 34px;
	}
	@media (max-width: 420px) {
		font-size: 26px;
	}
}

.position-wrapper {
	width: 100%;
	max-width: 800px;
	padding-top: 90px;
	padding-bottom: 60px;

	@media (max-width: $mq-xs-max) {
		padding-bottom: 30px;
		padding-top: 30px;
		padding-left: 15px;
		padding-right: 15px;
	}
}

.container {
	position: relative;
}

.inner_btn {
	display: flex;
	align-items: center;
	gap: 10px;
	justify-content: center;
}

.back-button {
	position: absolute;
	top: 80px;
	right: 0;
	padding: 10px;
	padding-bottom: 5px;
	padding-left: 2px;
	padding-right: 2px;
	margin-right: 30px;
	font-size: 13px;
	letter-spacing: 0.26px;
	font-weight: 500;
	font-family: "Inter UI", sans-serif;
	color: #000;
	border-bottom: 2px solid #000;
	@media (max-width: $compact) {
		top: 50px;
	}
	.mobile-button {
		display: none;

		@media (max-width: $compact) {
			top: 0px;
			padding: 0px;
		}
	}
	@media (max-width: $tablet) {
		.full-text-button {
			display: none;
		}

		border-bottom: none;
	}
}

.button-wrapper {
	position: absolute;
	left: 0;
	text-align: right;
	width: 100%;
	padding-right: 20px;
	@media (max-width: $tablet) {
		position: relative;
	}
}

.apply-button {
}

.arrow-down {
	display: inline-block;
	transform: rotateZ(180deg);
}

.list--unstyled {
	li {
		font-family: "Inter UI", sans-serif;
		font-size: 18px;
		letter-spacing: 0.02px;
		line-height: 25px;
		font-weight: 400;
	}
	.list-heading {
		font-family: "Inter UI", sans-serif;
		font-size: 18px;
		letter-spacing: 0.02px;
		line-height: 25px;
		font-weight: 700;
		margin-bottom: 5px;
	}
}

.positionHeaderBackground {
	background-image: url("/static/img/backgrounds/pattern-stippled_2.png");

	background-size: 40%;
	background-blend-mode: multiply;
	display: block;
	@media (min-width: $tablet) {
	}
}

.solid--bg {
	background-size: cover;
	width: 100%;
	height: 100%;
	position: relative;
}

.solid--bg:after {
	position: absolute;
	content: "";
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
}

.positionInfo--wrapper {
	position: relative;
	min-height: calc(100vh - 90px);
	display: flex;
	align-items: center;
	padding: 40px;
	@media (max-width: $tablet) {
		min-height: 100vh;
		padding: 40px;
	}
	@media (max-width: $mq-xs-max) {
		align-items: flex-start;
		min-height: 100%;
		padding: 0px;
		//padding-top: 40px;
	}
}

.positionInfo {
	width: 100%;
	font-size: 1rem;
	padding: em(75) em(110) em(71) em(98);
	@media (max-width: $mq-xs-max) {
		padding: 1rem 1.5rem 1.5rem 1.5rem;
	}
	background-color: white;

	@media (max-width: $mq-lg-max) {
		font-size: 0.7rem;
	}

	@media (max-width: $mq-md) {
		padding-left: em(70);
		padding-right: em(70);
	}

	@media (max-width: $mq-md-min) {
		padding-left: em(40);
		padding-right: em(40);
	}

	@media (max-width: $compact) {
		margin: auto;
		max-width: 100%;
		font-size: 0.8rem;
	}

	.heading {
		font-size: 60px;
		word-wrap: break-word;
	}

	.paragraph {
		word-wrap: break-word;
		max-width: 100%;
		font-family: "Inter UI", sans-serif;
		font-size: 16px;
		font-weight: 400;
		line-height: 28px;
		letter-spacing: 0.02px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/positionPageComponents/PositionHeader.vue